import ItemModel from '../../models/Inventory/InventoryItemModel';
import BaseStore from '../BaseStore';

class ItemStore extends BaseStore {
  constructor(transportLayer) {
    super(ItemModel, transportLayer);
  }
}

export default ItemStore;



// WEBPACK FOOTER //
// ./src/stores/Inventory/InventoryItemStore.js